import { render, staticRenderFns } from "./SelecionaComponente.vue?vue&type=template&id=74560878"
import script from "./SelecionaComponente.vue?vue&type=script&lang=js"
export * from "./SelecionaComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports